import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TagsInputComponent} from './tags-input.component';
import {FormsModule} from '@angular/forms';
import {SharedModule} from '../../shared.module';
import {TypeaheadModule} from "ngx-bootstrap/typeahead";

@NgModule({
	imports: [
	    CommonModule,
        FormsModule,
        SharedModule,
        TypeaheadModule.forRoot()
    ],
	declarations: [
        TagsInputComponent
	],
	exports: [
        TagsInputComponent
	]
})
export class TagsInputModule {}
